export const c360ThemeColors = {
  'c360-primary': '#E30A7B',
  'c360-charcoal-gray': '#6A6A6A',
  'c360-charcoal': '#3D3D3D',
  'c360-gray2': '#F5F5F5',
  'c360-gray': '#A2A2A2',
  'c360-compulse': '#E30A7B',
  'c360-light-gray': '#E6E6E6',
};
